﻿/**
 * Global Script
 * @namespace curriculum
 */

/** String object extensions */

(function () {
	'use strict';

	/** check to see if a string contains another string */
	String.prototype.contains = function(str){
		return this.toLowerCase().indexOf(str.toLowerCase()) > -1;
	};

	/** remove the specified string from the given string */
	String.prototype.remove = function(str){
		if (this.contains(str)) return this.replace(str, '');
	};

	/** strip html */
	String.prototype.stripHtml = function() {
		var tmp = document.createElement('div');
		tmp.innerHTML = this;
		return tmp.textContent || tmp.innerText || '';
	};

	/** Array Extensions */

	/** check an array for an item and return true or false */
	Array.prototype.contains = function(item){
		return $.inArray(item, this) > -1;
	};

	/** remove an entry from an array */
	Array.prototype.remove = function(item){
		if (this.contains(item)){
			this.splice($.inArray(item, this), 1);
		}
	};

	/** compare array to another array and return missing values */
	Array.prototype.compare = function(array){
		var missingValues = [];
		for (var i = 0; i < this.length; i++){
			if (!array.contains(this[i])) missingValues.push(this[i]);
		}
		return missingValues;
	};
})();